<template>
    <div class="mobile-wallets-checkout py-1">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="blue darken-3" size="30" width="2"></v-progress-circular>
        </div>
        <iframe v-else :href="iframeUrl" :src="iframeUrl" width="100%" border="none" style="border: none; height: 100%; overflow-x: hidden;" :style="`min-height: ${pcOnly ? '550px' : '75vh'};`" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        amount: {
            required: true,
        }
    },
    data(){
        return {
            loading: false,
            iframeUrl: null,
            
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
        initPaymob(){
            if (!this.loading){
                this.loading = true;
                  
                this.$store.dispatch('createPaymobCardOrder', {amount: this.amount}).then(response=>{
                    this.loading = false;
                    this.iframeUrl = response.data.iframe_url;

                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، حاول مرة أخرى', 'error');
                })
            }
        }
    },
    mounted(){
        if (!this.iframeUrl){
            this.initPaymob();
        }
    }
}
</script>

<style lang="scss">
.mobile-wallets-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}
</style>